import { CiUser } from "react-icons/ci";
import { CiLock } from "react-icons/ci";
import './Login.css';

const Login = () => {

  return (
    <>
        <div className="wrapper_login">
            <div className="login_box">
                <div className="login-header">
                    <span>Logga In</span>
                </div>
                <div className="input_box">
                    <input type='text' id='user' className='input-field' required />
                    <label for='user' className="label">Användarnamn</label>
                    <CiUser className="icon"/>
                </div>
                    <div className="input_box">
                    <input type='password' id='pass' className='input-field' required />
                    <label for='user' className="label">Lösenord</label>
                    <CiLock className="icon" />
                </div>
                <div className="input_box">
                    <input type="submit" className="input-submit" value='Logga In' />
                </div>
                <div className="register">
                    <span>Har du inget konto? <a href="#">Registrera</a></span>
                </div>
            </div>
        </div>
    </>
  )
}

export default Login